import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  get,
} from 'lodash';
import {
  transparent,
  withRouter,
} from 'vibeguide';
import MessageBlock from '../../../../../Programs/Baselines/Calendar/Items/MessageBlock';
import './MessageBlockItem.scss';

function MessageBlockItem({
  style = {},
  messageBlock = {},
  minStartTime = '',
  maxStopTime = '',
  color,
  fullView = false,
  params,
  readOnly = false,
}) {
  const [hover, setHover] = useState(false);

  const onMouseEnter = () => {
    setHover(true);
  };

  const onMouseLeave = () => {
    setHover(false);
  };

  const locationId = params.id;
  const archived = !get(messageBlock, 'messageBlock.active');

  const color10 = transparent(color, 10);
  const color20 = transparent(color, 20);
  const color25 = transparent(color, 25);
  const color35 = transparent(color, 35);
  const color84 = transparent(color, 84);

  const itemStyle = {
    background:
      hover
        ? archived
          ? `repeating-linear-gradient(45deg, ${color25}, ${color25} 10px, ${color35} 10px, ${color35} 20px)`
          : color35
        : archived
          ? `repeating-linear-gradient(45deg, ${color10}, ${color10} 10px, ${color20} 10px, ${color20} 20px)`
          : color25,
    border: `1px solid ${color84}`,
    boxSizing: 'border-box',
    ...style,
  };

  return (
    <div
      className="MessageBlockItem"
      style={itemStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {fullView && (
        <MessageBlock
          id={messageBlock._uniqueId}
          messageBlock={messageBlock.messageBlock}
          locationId={locationId}
          startTime={messageBlock.startTime}
          stopTime={messageBlock.stopTime}
          minStartTime={minStartTime}
          maxStopTime={maxStopTime}
          archived={archived}
          readOnly={readOnly}
        />
      )}
    </div>
  );
}

MessageBlockItem.propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  messageBlock: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  /** Prevent starting before */
  minStartTime: PropTypes.string,
  /** Prevent stopping after */
  maxStopTime: PropTypes.string,
  color: PropTypes.string.isRequired,
  /** View entire item */
  fullView: PropTypes.bool,
  /** All data in the schedule is read-only */
  readOnly: PropTypes.bool,
};

export default withRouter(MessageBlockItem);
